// Allows for English letters, some characters in Spanish, etc., apostrophes, hyphens, commas, periods and spaces. At least one English letter is required.
export const NAME_REGEX = /^(?=.*[A-Za-zÀ-ÿ])[A-Za-zÀ-ÿ ',.-]+$/;

// Allows for five-digit zip codes and nine-digit zip codes with or without a hyphen.
export const ZIP_CODE_REGEX = /^\d{5}(-?\d{4})?$/;
